<template>
    <!--  <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">-->
    <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">
        <Header/>
        <div
            :class="$i18n.locale=='العربية'?'FrameWork__PageWrapper-v8gq48-13 eRmiUC':'FrameWork__PageWrapper-v8gq48-13 obiMX'"
            :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '">
            <section class="style__SpotlightInnerWrap-sc-1qapdh8-0 kKgHVc">
                <div class="spotlight"
                     :style="$i18n.locale == 'العربية' ?'float:right;width:100%;':'float:left;width:100%;'">
                    <div class="style__SpotlightItemStyled-vo40go-0 cDscbW">
                        <figure>
                            <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">
                                <div aria-hidden="true" style="width:100%;padding-bottom:49.5%"></div>

                                <picture v-if="this.pagedata"><img
                                    :src="this.serverurl+'/public/pagebanners/'+pagedata.pagebanner"
                                    alt=""
                                    style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>

                                </picture>


                            </div>
                        </figure>
                        <div class="spotlight__info"
                             :style="$i18n.locale == 'العربية' ?'float:right;width:100%;padding-left:8%;padding-right:8%':'float:left;margin-left:3%;width:100%;padding-left:8%;padding-right:8%'">
                            <div class="react-reveal"
                                 style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                <div class="style__SectionTitleStyled-d40vxv-0 kcvceY"
                                     :style="$i18n.locale == 'العربية' ?'float:right;margin-right:3%;width: 50%;':'float:left;margin-left:3%;width: 50%;'">
                                    <h2 v-if="pagedata"
                                        :style="$i18n.locale == 'العربية' ? 'text-align: right;font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'">
                                        {{
                                            $i18n.locale == 'en' ? pagedata.page_entitle : $i18n.locale == 'العربية' ? pagedata.page_artitle : $i18n.locale == '中文' ? pagedata.page_chtitle : $i18n.locale == 'Русский' ? pagedata.page_rutitle : pagedata.page_frtitle
                                        }}</h2>
                                    <br/>

                                    <h3 v-if="pagedata"
                                        :style="$i18n.locale == 'العربية' ?'text-align: right;font-size: 23px!important;color:#ffffff;font-family: Cairo,sans-serif !important;margin-right:2%;':'font-size: 23px!important;color:#ffffff;font-family: Comfortaa!important;margin-left:2%'">
                                        {{
                                            $i18n.locale == 'en' ? pagedata.en_subtitle : $i18n.locale == 'العربية' ? pagedata.ar_subtitle : $i18n.locale == '中文' ? pagedata.ch_subtitle : $i18n.locale == 'Русский' ? pagedata.ru_subtitle : pagedata.fr_subtitle
                                        }}</h3>
                                </div>
                            </div>
                            <div class="btn_wrap"
                                 :style="$i18n.locale == 'العربية' ?'width:100%;float:right!important;margin-right:3%!important':'width:100%;float:left;margin-left:3%!important'">

                                <div class="react-reveal"
                                     :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg"
                                         style="width: 100%!important;text-align: center!important;"><a
                                        :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'"
                                        href="https://marketequityinc.com/custom/devicelink.php"
                                        target="_blank"
                                        rel="noopener noreferrer"><span>
                                        {{
                                            $i18n.locale == 'en' ? 'Download The App' : $i18n.locale == 'العربية' ? 'قم بتحميل التطبيق ' : $i18n.locale == '中文' ? 'Download The App' : $i18n.locale == 'Русский' ? 'Download the app' : 'Download The App'
                                        }}


                                        </span></a></div>
                                </div>
                                <div class="react-reveal"
                                     :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg"
                                         style="width: 100%!important;text-align: center!important;">
                                        <a :style="$i18n.locale == 'العربية' ? 'color:#ffffff!important;font-family: Cairo,sans-serif !important;' :'color:#ffffff!important;font-family: Comfortaa!important;'"
                                           href="#Marketequitycarddiv"><span>
                                            {{
                                                $i18n.locale == 'en' ? 'User Guidelines' : $i18n.locale == 'العربية' ? 'دليل المستخدم ' : $i18n.locale == '中文' ? ' Request your Prepaid Card' : $i18n.locale == 'Русский' ? 'Request your Prepaid Card' : 'Request your Prepaid Card'
                                            }}
                                        </span></a></div>
                                </div>
                            </div>

                            <!--                            <div class="btn_wrap"-->
                            <!--                                 :style="$i18n.locale == 'العربية' ?'width:100%;float:right!important;margin-right:10%!important;font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;width:100%;float:left;margin-left:10%!important'">-->
                            <!--                                <div class="react-reveal"-->
                            <!--                                     :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">-->
                            <!--                                    <div class="style__ButtonWrap-kitu94-0 hqzysg" :style="$i18n.locale == 'العربية' ? 'width: 100%!important;text-align: center!important;font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'"-->
                            <!--                                    >-->
                            <!--                                        <a-->
                            <!--                                        style="color:#ffffff!important;"-->
                            <!--                                        data-toggle="modal" data-target="#exampleModalLong"><span>-->
                            <!--                                            {{-->
                            <!--                                            $i18n.locale == 'en' ? 'Get Your Card Now' : $i18n.locale == 'العربية' ? 'حصل على بطاقتك الآن' : $i18n.locale == '中文' ? ' Get Your Card Now' : $i18n.locale == 'Русский' ? 'Get Your Card Now' : 'Get Your Card Now'-->
                            <!--                                        }}-->
                            <!--                                        </span></a></div>-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                        </div>
                    </div>
                </div>
            </section>








<!--            <div-->
<!--                :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'"-->
<!--                class="modal fade bd-example-modal-xl" id="exampleModalLong" tabindex="-1" role="dialog"-->
<!--                aria-labelledby="exampleModalLongTitle" aria-hidden="true">-->
<!--                <div style="max-width: 1000px!important;" class="modal-dialog modal-xl" role="document">-->
<!--                    <div class="modal-content">-->
<!--                        &lt;!&ndash;                        <div class="modal-header">&ndash;&gt;-->
<!--                        &lt;!&ndash;                            <h5 class="modal-title" id="exampleModalLongTitle">Registration</h5>&ndash;&gt;-->

<!--                        &lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                        <div class="modal-body">-->

<!--                            <form id="register">-->
<!--                                <div class="banner">-->

<!--                                </div>-->
<!--                                <div>-->
<!--                                    <h4 :style="$i18n.locale == 'العربية' ?'margin-top:2%;margin-bottom:2%;text-align:right;font-family: Cairo,sans-serif !important;':'margin-top:2%;margin-bottom:2%;text-align:left;font-family: Comfortaa!important;'">-->
<!--                                        {{-->
<!--                                            $i18n.locale == 'العربية' ? 'بطاقة ماركت إكويتي مسبقة الدفع ' : 'Market Equity Prepaid Card'-->

<!--                                        }}</h4>-->
<!--                                </div>-->
<!--                                <div>-->
<!--                                    <h4 :style="$i18n.locale == 'العربية' ?'margin-top:2%;margin-bottom:2%;text-align:right;font-family: Cairo,sans-serif !important;':'margin-top:2%;margin-bottom:2%;text-align:left;font-family: Comfortaa!important;'">-->
<!--                                        {{-->
<!--                                            $i18n.locale == 'العربية' ? ' سجل الآن' : 'Registration'-->
<!--                                        }}</h4></div>-->
<!--                                <div class="form-group row">-->
<!--                                    <label-->
<!--                                        :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;text-align: right; font-size: 16px;' :'font-family: Comfortaa!important;text-align: left; font-size: 16px;'"-->
<!--                                        for="inputPassword"-->
<!--                                        class="col-sm-2 col-form-label">-->
<!--                                        {{ $i18n.locale == 'العربية' ? 'الاسم الكامل' : 'Full Name' }}-->
<!--                                    </label>-->

<!--                                    <input v-bind:class="{ 'is-invalid': nameError }"-->
<!--                                           :style="$i18n.locale == 'العربية' ? 'margin-right:1%;margin-left:1%':'margin-left:1%;margin-right:1%;'"-->
<!--                                           type="text" class="form-control" id="inputPassword"-->
<!--                                           v-model="registername">-->
<!--                                </div>-->
<!--                                <div class="form-group row">-->
<!--                                    <label-->
<!--                                        :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;text-align: right; font-size: 16px;' :'font-family: Comfortaa!important;text-align: left; font-size: 16px;'"-->
<!--                                        for="inputPassword"-->
<!--                                        class="col-sm-6 col-form-label">-->
<!--                                        {{-->
<!--                                            $i18n.locale == 'العربية' ? 'اهل انت عميل لدينا؟' : 'Are you an existing client? '-->
<!--                                        }}-->
<!--                                    </label>-->


<!--                                </div>-->
<!--                                <div class="control-group"-->
<!--                                     :style="$i18n.locale == 'العربية' ? 'margin-right:2%!important;text-align:right!important;':'margin-left:2%!important;text-align:left!important;'">-->
<!--                                    <div clas="controls">-->
<!--                                        <div class="radio">-->
<!--                                            <input style="width: 20px!important;" id="existingyes" name="existingyes"-->
<!--                                                   type="radio" value="Managing editor" v-model="userexists" @change="changevalue()"-->
<!--                                            >-->

<!--                                            <label-->
<!--                                                :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;text-align: right; font-size: 16px;padding-right: 3%!important;' :'font-family: Comfortaa!important;text-align: left; font-size: 16px;'">-->
<!--                                                {{ $i18n.locale == 'العربية' ? 'انعم' : 'Yes ' }}-->
<!--                                            </label>-->

<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="control-group"-->
<!--                                     :style="$i18n.locale == 'العربية' ? 'margin-right:2%!important;text-align:right!important;':'margin-left:2%!important;text-align:left!important;'">-->
<!--                                    <div clas="controls">-->
<!--                                        <div class="radio">-->
<!--                                            <input style="width: 20px!important;" id="existingno" name="existingyes"   @change="changevalueno()"-->
<!--                                                   type="radio" value="existingno" checked>-->

<!--                                            <label-->
<!--                                                :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;text-align: right; font-size: 16px;padding-right: 3%!important;' :'font-family: Comfortaa!important;text-align: left; font-size: 16px;'">-->
<!--                                                {{ $i18n.locale == 'العربية' ? 'لا' : 'No' }}-->
<!--                                            </label>-->

<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="form-group row" v-if="userexists">-->
<!--                                    <div v-if="gifshow"-->
<!--                                         :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'"-->
<!--                                         class="modal fade bd-example-modal-xl show" id="exampleModalLongvideo" tabindex="-2" role="dialog"-->
<!--                                         aria-labelledby="exampleModalLongTitle" aria-hidden="true">-->
<!--                                        <div style="max-width: 1000px!important;" class="modal-dialog modal-xl" role="document">-->
<!--                                            <div class="modal-content">-->
<!--                                                &lt;!&ndash;                        <div class="modal-header">&ndash;&gt;-->
<!--                                                &lt;!&ndash;                            <h5 class="modal-title" id="exampleModalLongTitle">Registration</h5>&ndash;&gt;-->

<!--                                                &lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                                                <button type="button" class="btn btn-secondary" @click="gifclose()"> {{-->
<!--                                                        $i18n.locale == 'العربية' ? 'غلق  ' : 'Close'-->
<!--                                                    }}</button>-->

<!--                                                <div class="modal-body">-->

<!--                                                    <a href="https://devbackup.marketequityinc.com/public/public/303/20231122062006portal.gif"><img border="0" alt="CRM" src="https://devbackup.marketequityinc.com/public/public/303/20231122062006portal.gif" width="100%" height="100%"></a>-->
<!--                                                </div>-->


<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <label-->
<!--                                        :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;text-align: right; font-size: 16px;' :'font-family: Comfortaa!important;text-align: left; font-size: 16px;'"-->
<!--                                        for="inputPassword"-->
<!--                                        class="col-sm-6 col-form-label">-->
<!--                                        {{ $i18n.locale == 'العربية' ? 'رمز تعريف العميل  ' : 'Client ID' }}-->
<!--                                        <span v-on:mouseover="mouseover">?</span>-->
<!--                                    </label>-->

<!--                                    <input v-bind:class="{ 'is-invalid': acnumberError }"-->
<!--                                           :style="$i18n.locale == 'العربية' ? 'margin-right:1%;margin-left:1%':'margin-left:1%;margin-right:1%;'"-->
<!--                                           type="text" class="form-control"-->
<!--                                           id="acnumber"-->
<!--                                           v-model="acnumber">-->

<!--                                </div>-->

<!--                                <div class="form-group row">-->
<!--                                    <label-->
<!--                                        :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;text-align: right; font-size: 16px;' :'font-family: Comfortaa!important;text-align: left; font-size: 16px;'"-->
<!--                                        class="col-sm-6 col-form-label">{{-->
<!--                                            $i18n.locale == 'العربية' ? 'عنوان البريد الالكترونى' : 'Email Address'-->
<!--                                        }}</label>-->

<!--                                    <input  v-bind:class="{ 'is-invalid': emailError }"-->
<!--                                            :style="$i18n.locale == 'العربية' ? 'margin-right:1%;margin-left:1%':'margin-left:1%;margin-right:1%;'"-->
<!--                                            type="text" class="form-control" id="inputemail"-->
<!--                                            v-model="registeremail">-->

<!--                                    &lt;!&ndash; Button trigger modal &ndash;&gt;-->


<!--                                    &lt;!&ndash; Modal &ndash;&gt;-->
<!--                                </div>-->


<!--                                <div class="form-group row">-->
<!--                                    <label-->
<!--                                        :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;text-align: right; font-size: 16px;' :'font-family: Comfortaa!important;text-align: left; font-size: 16px;'"-->
<!--                                        class="col-sm-2 col-form-label">{{-->
<!--                                            $i18n.locale == 'العربية' ? 'رقم الهاتف' : 'Mobile'-->
<!--                                        }}</label>-->
<!--                                    <input  v-bind:class="{ 'is-invalid': phoneError }"-->
<!--                                            :style="$i18n.locale == 'العربية' ? 'margin-right:1%;margin-left:1%':'margin-left:1%;margin-right:1%;'"-->
<!--                                            type="text" class="form-control" id="inputmobile"-->
<!--                                            v-model="registermobile">-->


<!--                                </div>-->
<!--                                <div class="form-group row" style="text-align:center!important;" v-if="userexists">-->
<!--                                    <div class="btn-block">-->
<!--                                        <button-->
<!--                                            :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;margin-right:1%;margin-left:1%':'font-family: Comfortaa!important;margin-left:1%;margin-right:1%;'"-->
<!--                                            @click="cardtype(1)" type="button">-->
<!--                                            {{ $i18n.locale == 'العربية' ?'بطاقة رقمية ' : 'Virtual Card' }}-->
<!--                                        </button>-->
<!--                                        <button-->
<!--                                            :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;margin-right:1%;margin-left:1%':'font-family: Comfortaa!important;margin-left:1%;margin-right:1%;'"-->
<!--                                            @click="cardtype(2)" type="button">-->
<!--                                            {{ $i18n.locale == 'العربية' ? 'بطاقة السحب الألي ' : 'Debit Card' }}-->
<!--                                        </button>-->
<!--                                        <button-->
<!--                                            :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;margin-right:1%;margin-left:1%':'font-family: Comfortaa!important;margin-left:1%;margin-right:1%;'"-->
<!--                                            @click="cardtype(3)" type="button">-->
<!--                                            {{-->
<!--                                                $i18n.locale == 'العربية' ? 'كلاهما  ' : 'Both'-->
<!--                                            }}-->

<!--                                        </button>-->
<!--                                    </div>-->
<!--                                </div>-->

<!--                                <div class="form-group row" style="text-align:center!important;">-->
<!--                                    <div class="btn-block">-->
<!--                                        <button-->
<!--                                            :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;margin-right:1%;margin-left:1%':'font-family: Comfortaa!important;margin-left:1%;margin-right:1%;'"-->
<!--                                            @click="registergatetopay()" type="button">-->
<!--                                            {{ $i18n.locale == 'العربية' ? 'إرسال' : 'Submit' }}-->
<!--                                        </button>-->
<!--                                        <button-->
<!--                                            :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;margin-right:1%;margin-left:1%':'font-family: Comfortaa!important;margin-left:1%;margin-right:1%;'"-->
<!--                                            type="button" data-dismiss="modal" aria-label="Close" c>-->
<!--                                            <span aria-hidden="true"> {{-->
<!--                                                    $i18n.locale == 'العربية' ? 'غلق  ' : 'Close'-->
<!--                                                }}-->
<!--</span>-->
<!--                                        </button>-->
<!--                                    </div>-->
<!--                                </div>-->

<!--                                <p v-if="userexists" style="text-align:center!important;">  {{ $i18n.locale == 'العربية' ? 'كل فئة تخضع لرسوم دفع مختلفة ' : 'Each Category is Subject to Different Payment Fees' }}-->
<!--                                </p>-->
<!--                                <p v-if="!userexists" style="text-align:center!important;">  {{ $i18n.locale == 'العربية' ? 'للحصول على البطاقة مسبقة الدفع يجب أن يكون لديك حساب حقيقي ' : 'In order to acquire the pre-paid card, you need to have a real account. ' }}-->
<!--                                </p>-->
<!--                            </form>-->

<!--                        </div>-->

<!--                        <p style="color:red;" if="registererror">{{ this.registererror }}</p>-->
<!--                        <p style="color:green;" if="successregiter">{{ this.successregiter }}</p>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->


            <section v-if="pagedata.id!=38"
                     :style="pagedata.id==42 || pagedata.id==43?'background: rgb(244, 247, 248) none repeat scroll 0% 0%;':''"

                     :class="$i18n.locale=='العربية'?'FrameWork__InnerPageStyled-v8gq48-0 kVMyZl ':'FrameWork__InnerPageStyled-v8gq48-0 fHTiUO'" id="Marketequitycarddiv">


                <div
                    :style="pagedata.id==52 || pagedata.id==49 || pagedata.id==30?'max-width: 100%;padding-top:0px;':''"
                    v-if="pagedata.layout!=3" class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo"
                    style="opacity:1!important">

                    <div class="FrameWork__ContentData-v8gq48-10 ZBsdR"
                         :style="pagedata.id==52 || pagedata.id==30?'padding-top:0px;padding-right:0px;padding-left:0px;padding-bottom:0px!important':'padding-bottom:0px!important'">
                        <div class="FrameWork__Row-v8gq48-2 VIUMD"
                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                            <div
                                :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;padding-left:10%;padding-right:10%;padding-bottom:2%':'font-family: Comfortaa!important;margin-left:1%;padding-left:10%;padding-right:10%;padding-bottom:2%'"
                                v-html="$i18n.locale == 'en' ? pagedata.pagecontenten : $i18n.locale == 'العربية' ? pagedata.pagecontentar : $i18n.locale == '中文' ? pagedata.pagecontentch:$i18n.locale=='Русский'?pagedata.pagecontentru : pagedata.pagecontentfr
" class="FrameWork__ColSm-v8gq48-3 dIoETn">


                                {{
                                    $i18n.locale == 'en' ? pagedata.pagecontenten : $i18n.locale == 'العربية' ? pagedata.pagecontentar : $i18n.locale == '中文' ? pagedata.pagecontentch : $i18n.locale == 'Русский' ? pagedata.pagecontentru : pagedata.pagecontentfr
                                }}

                            </div>
                        </div>
                    </div>
                </div>


            </section>


            <iframe style="display: none; position: fixed; border: 0px none; overflow: hidden;"
                    src="https://marketequity.ladesk.com/scripts/generateWidget.php?v=5.21.17.15&amp;t=1607084151&amp;cwid=e00b30c6&amp;cwrt=C&amp;cwt=chat&amp;pt=Home%20page%20-%20Market%20Equity%20Inc%20-%20Leading%20Trading%20Service%20Provider&amp;ref=https%3A%2F%2Fmarketequity.com%2Fen%2F%23speciality"
                    allowfullscreen="true" allow="microphone; camera" tabindex="-1" class="i-embedded-chat"
                    id="icb_e00b30c6_305"></iframe>


            <Footer/>
        </div>

    </div>

</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'page',
    data() {
        return {
            pagedata: '',

            name: '',
            email: '',
            acnumber: '',
            message: '',
            emailnotify: null,
            registermobile: '',
            registererror: null,
            successregiter: null,
            userexists:false,
            cardtypeval:null,
            gifshow:false,
            nameError : false,
            emailError : false,
            phoneError : false,
            acnumberError:false




        }
    },
    components: {
        Header,
        Footer
    },
    mounted() {


        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js')
        document.head.appendChild(recaptchaScript)
    },
    beforeMount() {
        var pathvalues = (this.$route.path).split("/");
        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'العربية';
        }
        if (pathvalues[1] == 'ch') {
            this.$i18n.locale = '中文';
        }
        if (pathvalues[1] == 'fr') {
            this.$i18n.locale = 'Français';
        }
        if (pathvalues[1] == 'ru') {
            this.$i18n.locale = 'Русский';
        }

        this.pagenameroute = pathvalues[2];
        this.loadpagedata(pathvalues[2]);
    },

    methods: {
        mouseover(){
            this.gifshow = true
        },
        gifclose(){
            this.gifshow = false
        },
        // mouseleave(){
        //     this.gifshow = false
        // },
        cardtype(cardval)
        {
            this.cardtypeval=cardval;
        },

        validateEmail(email) {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        },
        changevalue(){
            this.userexists=true;
        },
        changevalueno(){
            this.userexists=false;
        },
        registergatetopay() {
            this.nameError=false;
            this.emailError=false;
            this.phoneError=false;
            this.acnumberError=false;

            this.registererror = null;
            this.successregiter = null;
            if(!this.registername)this.nameError=true;
            if(!this.registeremail)this.emailError=true;
            if(!this.registermobile)this.phoneError=true;

            if(this.userexists){
                if(!this.acnumber)this.acnumberError=true;


                if(!this.cardtypeval){
                    this.registererror = "Please click any  Card type ";
                    return false;

                }
                if (!this.registeremail || !this.registermobile || !this.registername || !this.acnumber) {
                    this.registererror = "الرجاء تعبئة جميع البيانات";
                    return false;
                }
            }
            if(!this.userexists){
                if (!this.registeremail || !this.registermobile || !this.registername ) {
                    this.registererror = "الرجاء تعبئة جميع البيانات";
                    return false;
                }
                else{
                    this.cardtypeval="Not an Existing User";
                    this.acnumber="Not an Existing User"
                }
            }

            if (!this.validateEmail(this.registeremail)) {
                this.registererror = "Invalid Data";
                return false;
            }


// alert(this.langchange)
            this.$axios.get("https://marketequity.com/custommail/gmail/gatetopayemail.php", {
                params: {

                    email: this.registeremail,
                    name: this.registername,
                    acnumber: this.acnumber,
                    mobile: this.registermobile,
                    cardtype: this.cardtypeval,
                    userexists:this.userexists


                }
            })
                .then(res => {
                    if (res) {
                        // alert(res);
                        console.log(res)

                        if (res.data.code == 200) {
                            alert("success");


                        } else {
                            this.errorregiter = "Error with Register. Please Register after some time";
                            this.webinarpageregisterflag = false;

                        }


                    }
                });
            this.successregiter = "Thank you for Registering. Our team will contact you ";
            this.registeremail = null;
            this.registername = null;
            this.acnumber = null;
            this.registermobile = null;
            //this.successregiter = null;

        },


        loadpagedata(pagename) {
            this.$axios.get("loadpagedata", {
                params: {
                    pagename: pagename
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                        if (res.data.code == 200) {
                            this.pagedata = res.data.pagedata[0];
                            this.pageblocksdata = res.data.pageblocksdata;
                            this.contractcat = res.data.contractcat;
                            this.swapscat = res.data.swapscat;
                            this.contractspecdetails = res.data.contractspecdetails;
                            this.swapsrate = res.data.swapsrate;
                            this.learningcoursesen = res.data.learningcoursesen;
                            this.learningcoursesar = res.data.learningcoursesar;
                            this.currencydata = res.data.currencydata;
                            this.crossesdata = res.data.crossdata;
                            this.articlesdata = res.data.articlesdata;
                            this.marketsoffer = res.data.marketsoffers;
                            this.faqcategories = res.data.faqcategories;
                            this.faq = res.data.faq;
                            this.currentdate = res.data.currentdate;
                            this.dayname = res.data.dayname;
                            this.daynamear = res.data.daynamear;

                            if (res.data.pagedata[0].layout == 3) {
                                this.loadcontactdata();
                            }
                        } else {

                            this.$router.push({name: 'NotFound'})
                        }
                    }
                });


        },
    }
}
</script>

<style>
#Marketequitycarddiv{
    scroll-behavior: smooth;

}


th {
    background-color: #005060;
    color: #ffffff;
}

tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

.carousel {
    background: #2f4357;
    margin-top: 20px;
}

.carousel-item {
    text-align: center;
    min-height: 280px; /* Prevent carousel from being distorted if for some reason image doesn't load */
}

.rtlclass {
    direction: rtl !important;
}

.ltrclass {
    direction: ltr !important;
}

select {
    width: 150px;
    line-height: 49px;
    height: 38px;
    font-size: 22px;
    outline: 0;
    margin-bottom: 15px;
}

.p {
    animation-fill-mode: both;
    animation-duration: 1000ms;
    animation-delay: 0ms;
    animation-iteration-count: 1;
    opacity: 1;
    animation-name: slideInUp;
}

#tabela th, td {
    padding: 10px !important;
}

tabela tr:nth-child(even) {
    background-color: none !important;
}

a:hover, a:focus {
    text-decoration: none;
    outline: none;
}

#accordionswap .panel-title a::before {

    content: "+";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: rgb(45, 174, 202) none repeat scroll 0% 0%;
    font-size: 12px;
    font-weight: 900;
    color: #ffffff;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
    text-shadow: none;
    position: absolute;
    top: 8px;
    left: 15px;

}

#accordionswap .panel-title a {
    display: block;
    padding: 12px 15px 12px 50px;
    background: rgb(45, 174, 202) none repeat scroll 0% 0%;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 18px;
    font-weight: 200;
    color: #ffffff;
    text-shadow: 0px 0px 0px #fff;
    position: relative;
}

#accordionsmarket .panel-title a::before {

    content: "+";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: rgb(45, 174, 202) none repeat scroll 0% 0%;
    font-size: 12px;
    font-weight: 900;
    color: #ffffff;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
    text-shadow: none;
    position: absolute;
    top: 8px;
    left: 15px;

}

#accordionsmarket .panel-title a {
    display: block;
    padding: 12px 15px 12px 50px;
    background: rgb(45, 174, 202) none repeat scroll 0% 0%;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 18px;
    font-weight: 200;
    color: #ffffff;
    text-shadow: 0px 0px 0px #fff;
    position: relative;
}

#accordion .panel {
    border: none;
    border-radius: 3px;
    box-shadow: none;
    margin-bottom: 15px;
}

#accordion .panel-heading {
    padding: 0;
    border: none;
    border-radius: 3px;
}

#accordion .panel-title a {
    display: block;
    padding: 12px 15px 12px 50px;
    background: #ffffff;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 22px;
    font-weight: bold;
    color: #005060;
    text-shadow: 0px 0px 0px #fff;
    position: relative;

}

#accordion .panel-title a:before {
    content: "-";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: #929191;
    font-size: 12px;
    font-weight: 900;
    color: #fdfbfb;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
    text-shadow: none;
    position: absolute;
    top: 8px;
    left: 15px;
}

#accordion .panel-title a.collapsed:before {
    content: "+";
}

#accordion .panel-body {
    padding: 10px 15px;
    font-size: 15px;
    color: #222;
    line-height: 27px;
    border: none;
}

#accordion .panel-body p {
    margin-bottom: 0;
}

#analysis {
    content: " ";
    width: 100%;
    position: relative;
    left: 0px;
    margin-top: -60px;
    /*background-color: #0a558c!important;*/
    background: url("https://dev.marketequityinc.com/public/public/analysis.png");
    padding: 45px 0px 0px;
}

#analysis:hover {
    border-top: 0;
    border-bottom: 1px solid #d0d0d0;
    border-left: 1px solid #d0d0d0;
    border-right: 1px solid #d0d0d0;
    border-style: inset;
}

#analysiscrosses {
    content: " ";
    width: 100%;
    position: relative;
    left: 0px;
    margin-top: -60px;
    /*background-color: #0a558c!important;*/
    background: url("https://dev.marketequityinc.com/public/public/analysis.png");
    padding: 45px 0px 0px;

}

#analysiscrosses:hover {
    border-top: 0;
    border-bottom: 1px solid #d0d0d0;
    border-left: 1px solid #d0d0d0;
    border-right: 1px solid #d0d0d0;
    border-style: inset;
}

#analysisarticle {
    content: " ";
    width: 100%;
    position: relative;
    left: 0px;
    margin-top: -60px;
    /*background-color: #0a558c!important;*/
    background: url("https://dev.marketequityinc.com/public/public/analysis.png");
    padding: 45px 0px 0px;

}

#analysisarticle:hover {
    border-top: 0;
    border-bottom: 1px solid #d0d0d0;
    border-left: 1px solid #d0d0d0;
    border-right: 1px solid #d0d0d0;
    border-style: inset;
}

#accordionfaq .panel {
    border: none;
    border-radius: 3px;
    box-shadow: none;
    margin-bottom: 0px;
}

#accordionfaq .panel-heading {
    padding: 0;
    border: none;
    border-radius: 3px;
}

#accordionfaq .panel-title a {
    display: block;
    padding: 2px 15px 0px 2px;
    background: #ffffff;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 22px;
    font-weight: bold;
    color: #005060;
    text-shadow: 0px 0px 0px #fff;
    position: relative;

}

#accordionfaq .panel-title a p {
    margin-bottom: 11px !important;
    margin-left: 57px !important;
    margin-right: 57px !important;
}

#accordionfaq .panel-title a p::before {

    content: "+";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: rgb(45, 174, 202) none repeat scroll 0% 0%;
    font-size: 12px;
    font-weight: 900;
    color: #ffffff;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
    text-shadow: none;
    position: absolute;
    top: 8px;

}

#accordionfaq .panel-title a p::after {

    content: "+";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: rgb(45, 174, 202) none repeat scroll 0% 0%;
    font-size: 12px;
    font-weight: 900;
    color: #ffffff;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
    text-shadow: none;
    position: absolute;
    top: 8px;

}

.kVMyZl ul li::before {
    width: 24px;
    height: 16px;
}

.kVMyZl ul li::before {
    background: rgba(0, 0, 0, 0) url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkVBRDA2NjA4QTkyNTExRTlCQTlCRDRBRkUyNDkxRkU3IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkVBRDA2NjA5QTkyNTExRTlCQTlCRDRBRkUyNDkxRkU3Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RUFEMDY2MDZBOTI1MTFFOUJBOUJENEFGRTI0OTFGRTciIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RUFEMDY2MDdBOTI1MTFFOUJBOUJENEFGRTI0OTFGRTciLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5/utXoAAABT0lEQVR42qzUSyhEURjA8euQlZ1iQ1ZKs7KYMnkszcpCI5mVx4LdKFlYKVYsZCNlJQsbREYpz5IsTEkWFrNSysaCpCyYpuv/1adu08ncuXNO/Tr38fV999zzqPF93wu2zoM7r5r2kIpLjkYuV3FoPMeN5C10JxjCR53j/DEcoxYJRvPocgQ9uMU7uiW5PHRVYAAXyCFJ8pe/Fy4KjOFIDZL8Lfiy2gKz2MI60vgqDTDMekpESL6MFSwgA98WJCNIYJ8ifSET12MTc5jG4n/BUmAeV9ijSGuZ5A0Sh3GMYK3c1xgm5Vv/3w929AttrQln6Fe7YYZrdHu/0g2jCxuWuHbcoA29uAw7USZwhuR0yU1gJhATxzUKkHm6r2QlmJKDaptuSQ+qpO7Oczzrb3mqdKnZziKZ9A6c6n0Wo/iMslFsBYqYRDPymNJnkdqvAAMABqdQ+HPTgMsAAAAASUVORK5CYII=") no-repeat scroll right center / contain;
    content: " ";
    position: absolute;
    width: 18px;
    height: 14px;
    top: 8px;
    right: 0px;
}

/*!sc*/
.kVMyZl {
    position: relative;
    text-align: right;
    background-size: cover;
}

/*!sc*/
.kVMyZl p {
    margin-bottom: 25px;
}

/*!sc*/
.kVMyZl ul, .kVMyZl p, .kVMyZl ol {
    font-weight: 300;
    color: #000;
    font-size: 16px;
    line-height: 34px;
    font-weight: 400;
}

/*!sc*/
.kVMyZl ul {
    padding: 0 0 0 5px;
}

/*!sc*/
@media (min-width: 768px) {
    .kVMyZl ul {
        padding: 0 0 0 20px;
    }
}

/*!sc*/
.kVMyZl li {
    list-style: none;
    position: relative;
    margin-bottom: 10px;
    padding-right: 30px;
}

/*!sc*/
@media (min-width: 768px) {
    .kVMyZl li {
        padding-right: 40px;
    }
}

/*!sc*/
.kVMyZl ul li:before {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkVBRDA2NjA4QTkyNTExRTlCQTlCRDRBRkUyNDkxRkU3IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkVBRDA2NjA5QTkyNTExRTlCQTlCRDRBRkUyNDkxRkU3Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RUFEMDY2MDZBOTI1MTFFOUJBOUJENEFGRTI0OTFGRTciIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RUFEMDY2MDdBOTI1MTFFOUJBOUJENEFGRTI0OTFGRTciLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5/utXoAAABT0lEQVR42qzUSyhEURjA8euQlZ1iQ1ZKs7KYMnkszcpCI5mVx4LdKFlYKVYsZCNlJQsbREYpz5IsTEkWFrNSysaCpCyYpuv/1adu08ncuXNO/Tr38fV999zzqPF93wu2zoM7r5r2kIpLjkYuV3FoPMeN5C10JxjCR53j/DEcoxYJRvPocgQ9uMU7uiW5PHRVYAAXyCFJ8pe/Fy4KjOFIDZL8Lfiy2gKz2MI60vgqDTDMekpESL6MFSwgA98WJCNIYJ8ifSET12MTc5jG4n/BUmAeV9ijSGuZ5A0Sh3GMYK3c1xgm5Vv/3w929AttrQln6Fe7YYZrdHu/0g2jCxuWuHbcoA29uAw7USZwhuR0yU1gJhATxzUKkHm6r2QlmJKDaptuSQ+qpO7Oczzrb3mqdKnZziKZ9A6c6n0Wo/iMslFsBYqYRDPymNJnkdqvAAMABqdQ+HPTgMsAAAAASUVORK5CYII=) no-repeat;
    background-position: right center;
    background-size: contain;
    content: " ";
    position: absolute;
    width: 18px;
    height: 14px;
    top: 8px;
    right: 0;
}

/*!sc*/
@media (min-width: 768px) {
    .kVMyZl ul li:before {
        width: 24px;
        height: 16px;
    }
}

/*!sc*/
.kVMyZl ul li.cross:before {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBCQzdBNzFGRDE0NTExRTk5Qzc1QTQ1MEVEMTQ5ODMzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBCQzdBNzIwRDE0NTExRTk5Qzc1QTQ1MEVEMTQ5ODMzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MEJDN0E3MUREMTQ1MTFFOTlDNzVBNDUwRUQxNDk4MzMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MEJDN0E3MUVEMTQ1MTFFOTlDNzVBNDUwRUQxNDk4MzMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz66BrXQAAABZ0lEQVR42rSUvUvDQBiHNYiTm2AXoVOXTg4ZxOqoUwU/BgUHcXNy8A9xEAdHF0EyqDiVailVBwtSHDoXCqWg0NJBFzvE5+AnhJgml4IHDy9378fv7nJvJn3fn/jPMRVeWLh+3cRswPHblttjblNnFk7glpyboMOJCB7ANpQoPm9R3MSUlDMIO/8IsIMqZhEy8AT5mOJ5xWSUU00UkEgTswR9eIFCRFhBvr5im1G1nFFbQ6SDWYM6PEAx4C5qra6Yzqg6Ttzlmo+sD34n9sXv3Ph6qV5RxPiCXfiAC62dwREkvnHH8jn7EgqK+mP1QcSYhnM40K7NOIU5OITvsQXogxnMJazDDnhyvcOVGmwPPlNfEcXNDsuwKryA2wusl3UaewGK5zDPkIVlqESEVeTLKjZnJUBxF/MIQ1iBRswtNhQzVI5rc4J7aJvj0wcti0fQ0lW1lZsoUDPdSfFuir9yVx1dCzt+BBgAXR5gFqIiaRoAAAAASUVORK5CYII=) no-repeat;
    background-position: right center;
    background-size: contain;
}

/*!sc*/
.kVMyZl ol {
    list-style: decimal;
    padding-left: 20px;
}

/*!sc*/
.kVMyZl ol li {
    list-style: decimal;
    padding-left: 10px;
}

/*!sc*/
.kVMyZl h3 {
    text-transform: capitalize !important;
}

.kNCxBo {
    max-width: 100% !important;

}

.ZBsdR {

    padding-left: 0px !important;
    padding-right: 0px !important;
    padding-bottom: 2% !important;
}

.fHTiUO h3 {
    text-transform: capitalize !important;
}

.fHTiUO ul, .fHTiUO p, .fHTiUO ol {
}

.kcvceY h2 {

}

.JMaKG > div::before {
    background: #4dd1f0;
    content: " ";
    width: 1px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    left: 0;
    background: rgb(77, 209, 240) none repeat scroll 0% 0%;
    content: " ";
    width: 1px;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
}

.JMaKG > div::after {
    background: #fff;
    content: " ";
    width: 57px;
    height: 57px;
    position: absolute;
    top: 50%;
    border-bottom: 1px solid #4dd1f0;
    border-right: 1px solid #4dd1f0;
    display: none;
    left: -28px;
    -webkit-transform: translateY(-50%) rotate(-45deg);
    -ms-transform: translateY(-50%) rotate(-45deg);
    transform: translateY(-50%) rotate(-45deg);
    background: rgb(255, 255, 255) none repeat scroll 0% 0%;
    content: " ";
    width: 57px;
    height: 57px;
    position: absolute;
    top: 50%;
    border-bottom: 1px solid rgb(77, 209, 240);
    border-right: 1px solid rgb(77, 209, 240);
    display: none;
    right: -28px;
    transform: translateY(-50%) rotate(135deg);
}

.FCFMu::before {
    content: " ";
    background: url(data:image/png;base64,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) no-repeat left center;
    background-size: auto;
    position: absolute;
    background-size: contain;
    width: 30px;
    height: 55px;
    top: 0;
    right: 0;
}

.ecLciw > div {
    width: 60% !important;

    padding-right: 5% !important;
    margin-right: 1% !important;
}

.ZBsdR strong {
    font-weight: bold !important;

}

.kKgHVc .spotlight__info > div {
    text-align: left !important;
}

.kKgHVc > div p {
    font-family: Comfortaa !important;
}

.fHTiUO p {
    font-family: Comfortaa !important;
}

.fHTiUO p span {
    font-family: Comfortaa !important;
}

.fHTiUO span {
    font-family: Comfortaa !important;
}

.cDscbW .spotlight__info p {
    text-transform: capitalize !important;

}

.kcvceY {
    text-align: left !important;
}

.kcvceY h2, .lcaeBj h3 a, .lpdeLb > div h3 {
    text-transform: capitalize !important;
}

.cDscbW > figure::after {
    z-index: -1 !important;
}

.ifRyix > div .thumbOverlay {
    background-color: #1a859d ! imortant;
    border-radius: 50% !important;
    width: 300px !important;
    height: 300px !important;
}

.ifRyix > div::before {
    border: 0px !important;
}

.ifRyix > div::after {
    border: 0px !important;
}

.ifRyix > div .deposit {
    border-radius: 50% !important;
    width: 300px !important;
    height: 300px !important;
}

.ifRyix > div .thumbOverlay .btn_wrap a, .ifRyix > div .thumbOverlay .btn_wrap span {
    background: transparent !important;
}

.fHTiUO p {

    padding-left: 5% !important;
    padding-right: 5% !important;
    color: #151414 !important;
}

.ifRyix > div .details_wrap {

    cursor: pointer !important;
}

.htlbQg {
    padding-top: 0px !important;
}

.fHTiUO {
    margin-bottom: -5% !important;
}

.dIoETn {
    padding-bottom: 5% !important;
}

.ZBsdR strong {
    font-family: inherit !important
}

.kVMyZl ol, .kVMyZl p, .kVMyZl ul {
    font-family: inherit !important
}

.hqzysg a span {
    font-family: inherit !important

}

.cDscbW .spotlight__info p {
    font-family: inherit !important

}

.kNCxBo {
    background-image: url(https://devbackup.marketequityinc.com/public/public/129/20210614094716aboutusbg.png) !important;

}

.iQutzW {

    padding-top: 0px !important;
    padding-bottom: 0px !important;
    background: #fff !important;
}
</style>
<style>
html, body {
    min-height: 100%;
}

body, div, form, input, select, p {
    padding: 0;
    margin: 0;
    outline: none;
    font-family: comfortaa, sans-serif;
    font-size: 14px;
    color: #666;
    line-height: 22px;
}

h1 {
    position: absolute;
    margin: 0;
    font-size: 32px;
    color: #fff;
    z-index: 2;
    font-family: comfortaa;
    text-align: left;
}

h2 {
    font-weight: 400;
}

.testbox {
    display: flex;
    justify-content: center;
    align-items: center;
    height: inherit;
    padding: 20px;
}

form {
    width: 100%;
    padding: 20px;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 0 20px 0 #1a859d;
}

.banner {
    position: relative;
    height: 210px;
    background-image: url("https://devbackup.marketequityinc.com/public/public/302/20231115112753from-gate.gif");
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.banner::after {
    content: "";
    background-color: rgba(0, 0, 0, 0.4);
    position: absolute;
    width: 100%;
    height: 100%;
}

input, select {
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 3px;
}

input {
    width: calc(100% - 10px);
    padding: 5px;
}

select {
    width: 100%;
    padding: 7px 0;
    background: transparent;
}

.item:hover p, .item:hover i, .question:hover p, .question label:hover, input:hover::placeholder, a {
    color: #095484;
}

.item input:hover, .item select:hover {
    border: 1px solid transparent;
    box-shadow: 0 0 6px 0 #1a859d;
    color: #1a859d;
}

.item {
    position: relative;
    margin: 10px 0;
}

input[type="date"]::-webkit-inner-spin-button {
    display: none;
}

.item i, input[type="date"]::-webkit-calendar-picker-indicator {
    position: absolute;
    font-size: 20px;
    color: #a9a9a9;
}

.item i {
    right: 2%;
    top: 30px;
    z-index: 1;
}

[type="date"]::-webkit-calendar-picker-indicator {
    right: 1%;
    z-index: 2;
    opacity: 0;
    cursor: pointer;
}

input[type=checkbox] {
    display: none;
}

label.check {
    position: relative;
    display: inline-block;
    margin: 5px 20px 10px 0;
    cursor: pointer;
}

.question span {
    margin-left: 30px;
}

span.required {
    margin-left: 0;
    color: red;
}

label.check:before {
    content: "";
    position: absolute;
    top: 2px;
    left: 0;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    border: 1px solid #1a859d;
}

input[type=checkbox]:checked + .check:before {
    background: #1a859d;
}

label.check:after {
    content: "";
    position: absolute;
    top: 6px;
    left: 4px;
    width: 8px;
    height: 4px;
    border: 3px solid #fff;
    border-top: none;
    border-right: none;
    transform: rotate(-45deg);
    opacity: 0;
}

input[type=checkbox]:checked + label:after {
    opacity: 1;
}

.btn-block {
    margin-top: 10px;
    text-align: center;
}

button {
    width: 150px;
    padding: 10px;
    border: none;
    border-radius: 5px;
    background: #1a859d;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
}

button:focus {
    background: grey;
    font-family: comfortaa, sans-serif;
}

@media (min-width: 568px) {
    .name-item, .city-item {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .name-item input, .city-item input {
        width: calc(50% - 20px);
    }

    .city-item select {
        width: calc(50% - 8px);
    }
}

</style>
